import IMAGES from "constants/images";
import React from "react";
import { Button, Image } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const message = queryParams.get("message") || "Something went wrong.";

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light px-3">
      <div
        className="text-center  p-5 "
        style={{ maxWidth: "500px", width: "100%" }}
      >
        {/* <h1 className="text-danger mb-3">Oops!</h1> */}

              <Image
                src={IMAGES.notFound}
                alt=""
                height="100%"
                width="100%"
                className="mb-4"
                // className="imgUser"
              />
              {/* <h5>No data available</h5> */}
        <p className="text-muted mb-4">{message}</p>
        <div className="text-center w-100">
          <Button
            variant="info"
            onClick={() => {
              navigate("/");
            }}
            className="border-radius-100 px-5"
          >
            Go To Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
